// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Callout = require("../common/Components/Callout.bs.js");
let Intercom = require("../../reason/common/Intercom.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedProfilePublicActions = require("./UnifiedProfilePublicActions.bs.js");
let UnifiedYourProfilePublicNoticeQuery_graphql = require("../../__generated__/UnifiedYourProfilePublicNoticeQuery_graphql.bs.js");

let convertVariables = UnifiedYourProfilePublicNoticeQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfilePublicNoticeQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfilePublicNoticeQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedYourProfilePublicNoticeQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedYourProfilePublicNoticeQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedYourProfilePublicNoticeQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedYourProfilePublicNoticeQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedYourProfilePublicNoticeQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedYourProfilePublicNoticeQuery_graphql.node, convertVariables);

let Query_accountMemberRole_decode = UnifiedYourProfilePublicNoticeQuery_graphql.Utils.accountMemberRole_decode;

let Query_accountMemberRole_fromString = UnifiedYourProfilePublicNoticeQuery_graphql.Utils.accountMemberRole_fromString;

let Query_profileMemberVisibility_decode = UnifiedYourProfilePublicNoticeQuery_graphql.Utils.profileMemberVisibility_decode;

let Query_profileMemberVisibility_fromString = UnifiedYourProfilePublicNoticeQuery_graphql.Utils.profileMemberVisibility_fromString;

let Query = {
  accountMemberRole_decode: Query_accountMemberRole_decode,
  accountMemberRole_fromString: Query_accountMemberRole_fromString,
  profileMemberVisibility_decode: Query_profileMemberVisibility_decode,
  profileMemberVisibility_fromString: Query_profileMemberVisibility_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedYourProfilePublicNotice(props) {
  let __showHeader = props.showHeader;
  let showHeader = __showHeader !== undefined ? __showHeader : false;
  let data = use(undefined, undefined, undefined, undefined);
  let match = Intercom.useIntercom();
  let show = match.show;
  let viewerId = data.currentlyLoggedInAgent.id;
  let account = data.currentAccountV5;
  let isOwner = account.viewerProfileRole === "OWNER";
  let profile = account.profile;
  let match$1;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      let isSubject = profile.agent.id === viewerId;
      let notice = isOwner ? [
          isSubject ? "Your account's public profile shows your information" : `Your account's public profile shows ` + profile.agent.displayName,
          !isSubject
        ] : (
          isSubject ? [
              "Your edits appear on your account's public profile",
              false
            ] : undefined
        );
      match$1 = [
        "Individual profile",
        isSubject,
        notice
      ];
      break;
    case "TeamAccountProfile" :
      let publicEdits = profile.members.edges.some(edge => {
        if (edge === undefined) {
          return false;
        }
        let member = edge.node;
        switch (member.__typename) {
          case "UserBoundMember" :
            if (member.agent.id === viewerId) {
              return member.visibility === "PUBLIC";
            } else {
              return false;
            }
          case "DisplayOnlyMember" :
          case "__unselected" :
            return false;
        }
      });
      match$1 = [
        "Team member profile",
        publicEdits,
        undefined
      ];
      break;
    case "__unselected" :
      match$1 = UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
      break;
  }
  let notice$1 = match$1[2];
  let description = match$1[1] ? "Your personal and professional information belongs to you. Changes made here also appear anywhere your profile is shown publicly." : "Your personal and professional information belongs to you.";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      showHeader ? JsxRuntime.jsx(UnifiedProfileSettingsUI.Header.make, {
          title: "Your Profile",
          description: description,
          profileKind: match$1[0]
        }) : null,
      notice$1 !== undefined ? JsxRuntime.jsx(Callout.Info.make, {
          children: JsxRuntime.jsxs("div", {
            children: [
              notice$1[1] ? JsxRuntime.jsxs("p", {
                  children: [
                    "To change who is shown, ",
                    JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                      onClick: param => show(),
                      _type: "button",
                      children: "contact us"
                    }),
                    ". Our team can help you make this change."
                  ]
                }) : null,
              JsxRuntime.jsx(UnifiedProfilePublicActions.make, {
                account: account.fragmentRefs,
                viewLabel: "View public profile"
              })
            ],
            className: "space-y-4"
          }),
          title: notice$1[0]
        }) : null
    ]
  });
}

let make = UnifiedYourProfilePublicNotice;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
